export const HOT_SEAT_COMPLETE_PHASE_COOLDOWN = 1000;